import { render, staticRenderFns } from "./IconCurrencyDollarSolid.vue?vue&type=template&id=b112fb04"
import script from "./IconCurrencyDollarSolid.vue?vue&type=script&lang=js"
export * from "./IconCurrencyDollarSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports